

































































































































































































































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import {
  HubButton,
  HubCard,
  HubIcon,
  HubTextarea,
} from '@/components/HubComponents';
import { VEmojiPicker } from 'v-emoji-picker';
import io from 'socket.io-client';
import { LiveSocialChat } from '../../typings/components';

const EVENT = {
  AUTHENTICATE: 'chat:authenticate',
  FACEBOOK: {
    GET_MESSAGES: 'chat:facebook:get_messages',
    MESSAGE: 'chat:facebook:message',
    SEND_MESSAGE: 'chat:facebook:send_message',
  },
  INSTAGRAM: {
    GET_MESSAGES: 'chat:instagram:get_messages',
    MESSAGE: 'chat:instagram:message',
    SEND_MESSAGE: 'chat:instagram:send_message',
  },
};

export default Vue.extend({
  name: 'LiveSocialChat',

  components: {
    HubButton,
    HubCard,
    HubIcon,
    HubTextarea,
    VEmojiPicker,
  },

  props: {
    liveActive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      checkIconColor: 'accent',
      isReplying: false,
      messageIdToBeReplied: '',
      noAccountSelected: false,
      receivedMessagesData: [] as LiveSocialChat.MessageData[],
      select: '',
      selectedService: {} as Store.LiveSocial.LiveSocialNetwork,
      sendButtonIsLoading: false,
      showEmojiPicker: false,
      socketIO: null as any,
      typedMessage: '',
    };
  },

  computed: {
    ...mapGetters('liveSocial', ['createdServices']),
    ...mapState(['liveSocial']),
    chatWebsocket(): any | undefined {
      return this.liveSocialState.chatWebsocket;
    },
    facebookLiveServices(): LiveSocialChat.LiveServices[] {
      const liveServices = [] as LiveSocialChat.LiveServices[];

      this.liveSocialState.providers.facebook.forEach((account) => {
        if (!account.lives?.length) return;

        account.lives.forEach((service) => {
          if (service.status) {
            liveServices.push({ ...service, user_id: account.user_id });
          }
        });
      });

      return liveServices;
    },
    liveIsEnabledForPages(): boolean {
      return (this.createdServices as Store.LiveSocial.LiveSocialNetwork[])
        .some((service) => service.status);
    },
    liveSocialState(): Store.LiveSocial.State {
      return this.liveSocial;
    },
  },

  watch: {
    facebookLiveServices() {
      if (this.liveIsEnabledForPages) {
        if (!this.chatWebsocket) {
          this.connectToWebsocket();

          return;
        }

        this.facebookLiveServices.forEach((service) => {
          console.log('service', service);
          if (!service.websocketConnected) this.enableWebsocketChannels(service);
        });
      }
    },
    liveIsEnabledForPages() {
      if (!this.liveIsEnabledForPages) {
        this.socketIO.disconnect();

        this.liveSocialState.providers.facebook.forEach((account) => {
          if (!account.lives?.length) return;

          account.lives.forEach((service) => {
            if (service.websocketConnected) {
              this.$store.commit('liveSocial/updateServiceWebsocket', {
                serviceId: service.id,
                websocketConnected: false,
              });
            }
          });
        });
      }
    },
  },

  methods: {
    connectToWebsocket() {
      this.socketIO = io(process.env.VUE_APP_FACEBOOK_API || '');

      this.socketIO.on('connect', () => {
        this.$store.commit('liveSocial/updateChatWebsocket', this.socketIO);

        this.socketIO.emit(EVENT.AUTHENTICATE, { token: process.env.VUE_APP_CHAT_WEBSOCKET_TOKEN });

        this.facebookLiveServices.forEach((service) => {
          if (!service.websocketConnected) this.enableWebsocketChannels(service);
        });
      });
    },
    enableWebsocketChannels(service: LiveSocialChat.LiveServices) {
      this.$store.commit('liveSocial/updateServiceWebsocket', {
        serviceId: service.id,
        websocketConnected: true,
      });

      // timeout: just to make sure the target/live has already been created
      setTimeout(() => {
        this.socketIO.emit(EVENT.FACEBOOK.GET_MESSAGES, {
          page_id: service.transmission_id,
          user_id: service.user_id,
        } as LiveSocialChat.FacebookGetMessages);

        this.socketIO.on(EVENT.FACEBOOK.MESSAGE, (data: LiveSocialChat.FacebookMessage) => {
          this.sendButtonIsLoading = false;

          if ('message' in data) {
            console.log(`[WS] ${EVENT.FACEBOOK.MESSAGE}`, data);

            if (this.receivedMessagesData.findIndex((message) => message.id === data.id) >= 0) {
              return;
            }

            let from = {
              id: '',
              name: `${this.$t('unknown')}`,
              picture: '',
            };

            if (data.from) {
              from = {
                ...data.from,
                picture: data.from.picture.data.url,
              };
            }

            this.receivedMessagesData.push({
              ...data,
              from,
              message: data.message.split('\n'),
              provider: 'facebook',
            });

            const chatContent = this.$el.querySelector('.live-social-chat__content');

            if (chatContent) {
              // timeout: just to make sure the new message is already in the array
              setTimeout(() => {
                chatContent.scrollTop = chatContent.scrollHeight;
              }, 200);
            }

            return;
          }

          console.error(data.error);
        });
      }, 15000);
    },
    getColor(provider: Store.LiveSocial.Provider) {
      switch (provider) {
        case 'facebook': return '#3B5998';
        case 'instagram': return '#C837AB';
        case 'twitch': return '#6441a5';
        case 'twitter': return '#03a9f4';
        case 'youtube': return '#C4302B';
        default: return '#00000080';
      }
    },
    onClickReply(messageId: string) {
      this.isReplying = true;

      this.messageIdToBeReplied = messageId;
    },
    onSendMessage() {
      const thereIsATypedMessage = !!this.typedMessage.trim();
      const thereIsSelectedService = !!Object.keys(this.selectedService).length;

      if (thereIsATypedMessage && thereIsSelectedService) {
        this.sendButtonIsLoading = true;

        const userId = this.facebookLiveServices
          .filter((service) => this.selectedService.id === service.id)[0]?.user_id;

        this.socketIO.emit(EVENT.FACEBOOK.SEND_MESSAGE, {
          comment_id: this.isReplying && this.messageIdToBeReplied,
          message: this.typedMessage,
          page_id: this.selectedService.transmission_id,
          user_id: userId,
        } as LiveSocialChat.FacebookSendMessage);

        this.isReplying = false;
        this.messageIdToBeReplied = '';
        this.typedMessage = '';

        return;
      }

      if (!thereIsATypedMessage) return;

      this.noAccountSelected = true;
    },
  },
});
